import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useCartActions } from '../hooks/useCart';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { clearCart } = useCartActions();

  useEffect(() => {
    const confirmPurchase = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setError('No session ID found');
        setLoading(false);
        return;
      }

      try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

        const purchaseResponse = await axios.get(
          `${API_BASE_URL}/stripe/session/${sessionId}/purchase`
        );
        const purchase = purchaseResponse.data.data;

        await clearCart();
        if (purchase.cartId) {
          await axios.delete(`${API_BASE_URL}/carts/${purchase.cartId}/items`).catch(() => {});
        }

        navigate(`/order-confirmation?session_id=${sessionId}`, { replace: true });
      } catch (error: any) {
        console.error('Error confirming purchase:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
        setError(
          `Failed to confirm your purchase: ${errorMessage}. Your payment was received — please contact support with your Stripe receipt.`
        );
        setLoading(false);
      }
    };

    confirmPurchase();
  }, [searchParams, navigate, clearCart]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 mx-auto mb-4" style={{ borderColor: '#39ff14' }}></div>
          <h2 className="text-2xl font-bold mb-2" style={{ color: '#39ff14' }}>Processing Your Order...</h2>
          <p className="text-gray-600">Please wait while we confirm your payment.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center">
          <div className="text-red-600 text-xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-red-600 mb-2">Payment Error</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 rounded-md font-bold hover:opacity-80 transition-colors"
            style={{ backgroundColor: '#39ff14', color: '#000' }}
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default PaymentSuccess;
